var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 61,
    viewBox: "0 0 47 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.921875 23.6609C0.921875 25.7237 1.19382 27.7699 1.73771 29.7498C4.19843 38.7407 20.6015 55.3292 22.5482 57.2759H5.2033C4.26805 57.2759 3.50531 58.0387 3.50531 58.9739C3.50531 59.9091 4.26808 60.6719 5.2033 60.6719H42.6354C43.5707 60.6719 44.3334 59.9091 44.3334 58.9739C44.3334 58.0387 43.5706 57.2759 42.6354 57.2759H25.2905C27.2339 55.3325 43.6466 38.7441 46.101 29.7498C46.6449 27.7733 46.9169 25.727 46.9169 23.6609C46.9169 10.9854 36.6033 0.671875 23.9278 0.671875C11.2523 0.671875 0.938752 10.9854 0.938752 23.6609H0.921875ZM43.504 23.6609C43.504 25.4186 43.2752 27.1663 42.8076 28.8478C40.8376 36.031 27.9239 49.6914 23.9005 53.8167C19.8777 49.6811 6.9639 36.0311 4.99338 28.8478C4.53573 27.1663 4.29695 25.4186 4.29695 23.6609C4.29695 12.8532 13.0917 4.06785 23.89 4.06785C34.6884 4.06785 43.4831 12.8626 43.4831 23.6609H43.504Z",
    fill: "#50a100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7402 22.8379C13.7402 28.4427 18.3003 33.0089 23.9112 33.0089C29.5221 33.0089 34.0821 28.4488 34.0821 22.8379C34.0821 17.227 29.5221 12.667 23.9112 12.667C18.3003 12.667 13.7402 17.227 13.7402 22.8379ZM30.687 22.8379C30.687 26.5721 27.6492 29.6133 23.9116 29.6133C20.1774 29.6133 17.1362 26.5755 17.1362 22.8379C17.1362 19.1037 20.174 16.0625 23.9116 16.0625C27.6458 16.0625 30.687 19.1003 30.687 22.8379Z",
    fill: "#50a100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cfc2ea26fa826e4d79e12507ec78b77e.svg";
export { ForwardRef as ReactComponent };